import { render, staticRenderFns } from "./QuestionLong.vue?vue&type=template&id=d495983a&scoped=true&"
import script from "./QuestionLong.vue?vue&type=script&lang=js&"
export * from "./QuestionLong.vue?vue&type=script&lang=js&"
import style0 from "./QuestionLong.vue?vue&type=style&index=0&id=d495983a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d495983a",
  null
  
)

export default component.exports